<script setup>
const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  allItems: {
    type: Array,
    default: null,
  },
  itemValue: {
    type: String,
    default: 'value',
  },
  itemTitle: {
    type: String,
    default: 'label',
  },
  itemColor: {
    type: String,
    default: 'color',
  },
  modelValue: {
    type: [Number, String],
    default: null,
  },
  api: {
    type: String,
    default: null,
  },
  colorDefault: {
    type: String,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['update:model-value'])

defineOptions({
  inheritAttrs: true,
})

const modelItem = computed(() => {
  const options = props.allItems ?? props.items ?? []
  
  return options.find(item => (item[props.itemValue] === props.modelValue))
})

const modelColor = computed(() => modelItem.value?.[props.itemColor] ?? props.colorDefault)

const loading = ref(false)
const attrs = useAttrs()

const handleItemChange = async value => {
  if (props.api) {
    loading.value = true

    const { data } = await useApi(props.api, {
      body: {
        status: value,
      },
      method: "PUT",
    })

    loading.value = false
    emit('update:model-value', value)
  } else if (attrs.onChange) {
    attrs.onChange(value)
  } else {
    emit('update:model-value', value)
  }
}
</script>

<template>
  <VMenu :disabled="disabled">
    <template #activator="{ props: activeProps }">
      <div>
        <VChip
          v-bind="activeProps"
          :color="modelColor"
          size="small"
          label
          :style="$attrs?.activatorStyle"
          class="text-capitalize"
        >
          {{ modelItem?.[itemTitle] ?? modelValue }}
          <template v-if="!disabled">
            <VIcon
              v-if="!loading"
              class="ms-1 me--1"
              icon="tabler-chevron-down"
            />
            <VProgressCircular
              v-else
              class="ms-1 me--1"
              size="18"
              :color="modelColor"
              indeterminate
              stroke-width="1px"
              striped
            />
          </template>
        </VChip>
      </div>
    </template>
    <VList class="pa-0">
      <VListItem
        v-for="(item, index) in items"
        :key="index"
        style="margin-block: 0; margin-inline: 0"
        :value="index"
        @click="handleItemChange(item[itemValue])"
      >
        <VListItemTitle class="pa-0">
          {{ item[itemTitle] }}
        </VListItemTitle>
      </VListItem>
    </VList>
  </VMenu>
</template>
